/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import Layout from 'components/partials/Layout';
import ForgotPasswordSteps from './components/ForgotPasswordSteps';
import EmailEnterence from './components/EmailEnterence';
import EmailVerification from './components/EmailVerification';
import PasswordReset from './components/PasswordReset';
import Success from './components/Success';

const ForgotPassword = ({ step, token }) => {
  const router = useRouter();

  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (step === 'email-verification' && _.isEmpty(email)) {
      router.push('/forgot-password/email-enterence');
    } else {
      setLoading(false);
    }
  }, [step]);

  const componentParams = {
    userId,
    setUserId,
    email,
    setEmail,
    token,
  };

  const steps = {
    'email-enterence': {
      component: <EmailEnterence {...componentParams} />,
      index: 0,
    },
    'email-verification': {
      component: <EmailVerification {...componentParams} />,
      index: 1,
    },
    'password-reset': {
      component: <PasswordReset {...componentParams} />,
      index: 2,
    },
    success: {
      component: <Success {...componentParams} />,
      index: 3,
    },
  };

  return (
    <main className="has-header">
      <div className="container">
        {
          loading
            ? null
            : (
              <div className={step !== 'success' ? 'row' : ''}>
                {steps[step].index < 3 && <ForgotPasswordSteps currentStep={steps[step].index} />}
                {steps[step].component}
              </div>
            )
        }
      </div>
    </main>
  );
};

ForgotPassword.propTypes = {
  step: PropTypes.string,
  token: PropTypes.string,
};

export const getServerSideProps = async ({ req, query, res }) => {
  const { t } = req;
  const step = query?.step;
  const token = query?.token || '';

  if (!_.includes(['email-enterence', 'email-verification', 'password-reset', 'success'], step)) {
    res.writeHead(302, { Location: '/404' });
    res.end();
  }

  return {
    props: {
      shortHeader: true,
      shortFooter: true,
      headTitle: t('forgotPassword'),
      step,
      token,
    },
  };
};

ForgotPassword.Layout = Layout;

export default withTranslation('common')(ForgotPassword);
